import api from "../../utils/apiUserTienda";

export async function obtenerResumenDashboardTienda() {
  try {
    const res = await api.get("/api/tienda/dashboard/resumen");
    return res.data;
  } catch (error) {
    return {
      ok: false,
      data: null,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "No se pudo cargar el dashboard.",
    };
  }
}
